export default __webpack_public_path__ + "static/media/gauntlets.fb7146f4.png";